import { useMemo } from 'react';

interface VideoSource {
  src: string;
  type: string;
}

interface UseVideoSourcesOptions {
  sources: VideoSource[];
  width?: number | string;
  height?: number | string;
  ariaLabel?: string;
}

export const useVideoSources = ({
  sources,
  width = '100%',
  height = '100%',
  ariaLabel,
}: UseVideoSourcesOptions) => useMemo(() => ({
  videoProps: {
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    preload: 'auto' as const,
    width,
    height,
    ...(ariaLabel ? { 'aria-label': ariaLabel } : {}),
  },
  sources,
}), [ariaLabel, height, sources, width]);
